// extracted by mini-css-extract-plugin
export var container = "_g1-1";
export var cornerButtonContainer = "_g1-6";
export var disabled = "_g1-2";
export var dragActive = "_g1-3";
export var fileContainer = "_g1-5";
export var hiddenInput = "_g1-4";
export var widthContainer = "_g1-0";